import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Order } from '../../../models/order.model';
import { Material } from '../../../models/material.model';
import { SharedService } from '../../../services/shared.service';
import { PermissionHelper } from '../../../helpers/permission.helper';

@Component({
  standalone: false,
  selector: 'app-warehouse-order-materials-list',
  templateUrl: './warehouse-order-materials-list.component.html',
  styleUrls: ['../modal.component.scss']
})

export class WarehouseOrderMaterialsListComponent {
  @Input() order: Order;
  @Output() readonly responseChanged = new EventEmitter();
  @Output() openedIssueMaterialModal = new EventEmitter();
  @Output() returnedMaterial = new EventEmitter();
  @Output() openedCorrectionMaterialIssuanceModal = new EventEmitter();

  constructor(public sharedService: SharedService,
              public permissionHelper: PermissionHelper
  ) {}

  showSpentQuantityMaterial(material: Material): number {
    const materialDifference = material.quantityIssued - material.quantityReturned;

    if (materialDifference && Math.floor(materialDifference) !== (materialDifference)) {
      return Number(materialDifference.toFixed(4));
    } else {
      return materialDifference;
    }
  }

  onOpenIssueMaterialModal(material: Material): void {
    this.openedIssueMaterialModal.emit(material);
  }

  onReturnMaterial(materialId: string): void {
    this.returnedMaterial.emit(materialId);
  }

  onOpenCorrectionOfMaterialIssuanceModal(material: Material): void {
    this.openedCorrectionMaterialIssuanceModal.emit(material);
  }

  emitFalse(): void {
    this.responseChanged.emit(null);
  }

  trackByFn(index): number {
    return index;
  }
}